/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'company-hub.links-menu-extension.alignment.title': 'Justering',
  'company-hub.links-menu-extension.all.borders.label-text': 'Alle sider',
  'company-hub.links-menu-extension.background.color': 'Baggrundsfarve',
  'company-hub.links-menu-extension.background.title': 'Baggrund',
  'company-hub.links-menu-extension.border.color': 'Kantfarve',
  'company-hub.links-menu-extension.border.position': 'Kantposition',
  'company-hub.links-menu-extension.bottom.border.label-text': 'Nederste kant',
  'company-hub.links-menu-extension.center.option': 'Centrér',
  'company-hub.links-menu-extension.config-panel.add-link-button.description': 'Tilføj vigtige links',
  'company-hub.links-menu-extension.config-panel.add-link-button.text': 'Link',
  'company-hub.links-menu-extension.config-panel.add-menu-button.description': 'Gruppér relaterede links sammen',
  'company-hub.links-menu-extension.config-panel.add-menu-button.disabled.tooltip-text':
    'Du har nået det maksimale antal indlejrede niveauer.',
  'company-hub.links-menu-extension.config-panel.add-menu-button.text': 'Menu',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.cancel-text': 'Annuller',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.confirm-text': 'Slet',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.description-text':
    'Med denne handling slettes dette element og alle indlejrede elementer.',
  'company-hub.links-menu-extension.config-panel.delete-nested-items-modal.title-text': 'Slet element',
  'company-hub.links-menu-extension.config-panel.item-dropdown.add-sub-item-button.text': 'Tilføj underelement',
  'company-hub.links-menu-extension.config-panel.item-dropdown.delete-item-button.text': 'Slet element',
  'company-hub.links-menu-extension.config-panel.item-dropdown.edit-properties-button.text': 'Rediger egenskaber',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-down.text': 'Flyt ned',
  'company-hub.links-menu-extension.config-panel.item-dropdown.move-item-up.text': 'Flyt op',
  'company-hub.links-menu-extension.config-panel.item-dropdown.open-link-button.text': 'Åbn linket',
  'company-hub.links-menu-extension.config-panel.items.label': 'Sager',
  'company-hub.links-menu-extension.config-panel.new-item-button.disabled.tooltip-text':
    'Du har nået det maksimale antal elementer, der kan tilføjes en linkmenu.',
  'company-hub.links-menu-extension.config-panel.new-item-button.text': 'Nyt element',
  'company-hub.links-menu-extension.config-panel.preamble':
    'Tilføj links, og organiser dem med undermenuer. {linksMenuSupportLink}',
  'company-hub.links-menu-extension.config-panel.preamble-link.label': 'Få mere at vide om linkmenu',
  'company-hub.links-menu-extension.config-panel.preamble-without-support-link':
    'Tilføj links, og organiser dem med undermenuer.',
  'company-hub.links-menu-extension.config-panel.property-config.cancel-button-label': 'Annuller',
  'company-hub.links-menu-extension.config-panel.property-config.confirm-button-label': 'Bekræft',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-error': 'Udfyld dette felt.',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-label': 'Vist tekst',
  'company-hub.links-menu-extension.config-panel.property-config.display-text-placeholder': 'Elementnavn',
  'company-hub.links-menu-extension.config-panel.property-config.link.submit-button-label': 'Bekræft',
  'company-hub.links-menu-extension.config-panel.property-config.more-button-label': 'Mere',
  'company-hub.links-menu-extension.config-panel.styles.label': 'Stile',
  'company-hub.links-menu-extension.config-panel.sub-item-button.disabled.tooltip-text':
    'Du har nået det maksimale antal elementer, der kan tilføjes en linkmenu.',
  'company-hub.links-menu-extension.config-panel.title': 'Menuen Links',
  'company-hub.links-menu-extension.fixed.option': 'Fastgjort øverst',
  'company-hub.links-menu-extension.left.option': 'Venstre',
  'company-hub.links-menu-extension.links-menu-content.links-menu-items.more.title': 'Mere',
  'company-hub.links-menu-extension.manifest.extension-description':
    'Tilføj flere links og undermenuer i virksomhedshub',
  'company-hub.links-menu-extension.manifest.extension-lozenge-title': 'Menuen Links',
  'company-hub.links-menu-extension.manifest.extension-title': 'Linkmenu [Ny]',
  'company-hub.links-menu-extension.manifest.first-default-item': 'Om os',
  'company-hub.links-menu-extension.manifest.nested-default-item': 'Team 1',
  'company-hub.links-menu-extension.manifest.second-default-item': 'Fordele',
  'company-hub.links-menu-extension.manifest.third-default-item': 'Teams',
  'company-hub.links-menu-extension.no.border.label-text': 'Ingen',
  'company-hub.links-menu-extension.right.option': 'Højre',
  'company-hub.links-menu-extension.section.collapse.label': 'Skjul sektion',
  'company-hub.links-menu-extension.section.expand.label': 'Udvid sektion',
  'company-hub.links-menu-extension.selected.state.color': 'Valgt tilstandsfarve',
  'company-hub.links-menu-extension.text.color': 'Tekstfarve',
  'company-hub.links-menu-extension.text.title': 'Tekst',
};
